export default "__VITE_ASSET__ThOZVlqb__"